import BreadCrumbs from '../share/BreadCrumb';
import { useState } from 'react';
import Link from 'next/link';

export default function PriceListHeader({ pagesList, title }) {
  const [LimitSubCats, setLimitSubCats] = useState(6);

  const openSubCats = () => {
    setLimitSubCats(-1);
  };
  return (
    <div className="pl-header">
      <BreadCrumbs objectTitle={title} />
      <div className=" cat-title flex items-center w-full md:w-auto  pl-10 text-base font-bold mb-4">
        <h1>{title}</h1>
      </div>

      <div className=" flex gap-3 overflow-y-auto flex-nowrap pb-2  custom-scroll-bar ">
        {pagesList.slice(0, LimitSubCats).map((pagePriceList, i) => (
          <Link
            href={`/page/${pagePriceList.url}`}
            key={i}
            className="border border-light-gray-300 rounded-md py-2 md:px-4 px-2  flex items-center"
          >
            <div className="text-xs whitespace-nowrap text-center md:font-bold py-2">
              {pagePriceList.title}
            </div>
          </Link>
        ))}
        {pagesList.length > 6 && (
          <div
            className={`bg-light-blue-200 min-w-[120px] cursor-pointer text-ocean-blue font-bold rounded-md text-center leading-9 flex flex-col text-xs md:text-sm justify-center ${
              LimitSubCats < 0 && 'hidden'
            }`}
            onClick={openSubCats}
          >
            <div>مشاهده همه </div>
          </div>
        )}
      </div>
    </div>
  );
}
